// service
import ConfigManager from "@/config/ConfigManager";
import BzbsApi from "@/core/Http/BzbsApi";
import AccountHelper from "@/helper/AccountHelper";
import { map } from 'rxjs/operators';

export const apiAddToCart = function (params) {
    let token = AccountHelper.getToken();
    params.device_app_id = ConfigManager.getAppId();
    let url = ConfigManager.getApiModuleUrl() + '/cart/add';

    return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
        return res.data;
    }));
}

export default function () {
    return {
        apiAddToCart
    }
}
